import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TlumaczeniaService } from '../../../tlumaczenia/serwisy/tlumaczenia.service';
import { ControllerStronyCmsOpenService } from "../../../api/controller-strony-cms-open.service"
import { StronaCmsListaDto } from "../../../modele/strona-cms-lista-dto";

const stronyCms: Array<string> = [
  "bef1033a-ecc5-4765-a812-d38bc3cc5ee1", //polityka prywatności
  "1d8637b8-1ce1-4fc3-bd93-e11335941853", //UM
  "52f1c0d2-b210-4f9d-af5c-232e0c3cab99", //Deklaracja dostępności
  "0ba4aaff-ce4f-42bf-a830-dc4058d15bc2", //19115
  "f5b7c2bc-0e82-4c00-819c-5319df3facb4" //Warunki ponownego wykorzystania
]
/**
 * Komponent stopki dla szablonu strony startowej
 */
@Component({
  selector: 'app-stopka',
  templateUrl: './stopka.component.html',
  styleUrls: ['./stopka.component.scss']
})
export class StopkaComponent implements OnInit, OnDestroy {

  $stronyCms = new Observable<StronaCmsListaDto[] | undefined>();
  subskrybcja = new Subscription();

  /**
   * Konstruktor
   * @param cmsService serwis do komunikacji z modułem cms
   * @param tlumaczeniaSerwis serwis tlumaczen
   */
  constructor(
    private cmsService: ControllerStronyCmsOpenService,
    private tlumaczeniaSerwis: TlumaczeniaService) {
  }

  /**
   * Cykl życia obiektu
   */
  ngOnInit(): void {
    this.wczytajListeStron();
    this.subskrybcja = this.tlumaczeniaSerwis.getZmianaJezykaSubject().subscribe(() => this.wczytajListeStron());
  }

  /**
   * Cykl życia obiektu
   */
  ngOnDestroy(): void {
    this.subskrybcja.unsubscribe();
  }

  /**
   * Funkcja wczytywania listy tematów pomocy
   */
  wczytajListeStron(): void {
    this.$stronyCms = this.cmsService.getStronyCms(this.tlumaczeniaSerwis.pobierzAktualnyJezyk())
      .pipe(map(val => val.content?.filter(strona => strona.ukryty === false)));
  }
}
